
import { props, createCarousel, reInitCarousel, autoplay } from './embla'
import { hyphenate } from 'vessel/utils'

export default {
  name: 'VsCarousel',
  provide() {
    return {
      carousel: this
    }
  },
  props: {
    items: {
      type: Array,
      default: null
    },
    trackActive: {
      type: Boolean,
      default: false
    },
    trackInView: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    autoplayInterval: {
      type: Number,
      default: 4000
    },
    tag: {
      type: String,
      default: 'div'
    },
    ...props
  },
  vessel: {
    wrapper: {
      $attrs: 'all'
    }
  },
  watch: {
    items() {
      this.$nextTick(() => {
        reInitCarousel(this)
      })
    },
    autoplay(newValue, oldValue) {
      if (newValue != oldValue) {
        this.stopAutoplay()
        this.startAutoplay()
      }
    },
    autoplayInterval(newValue, oldValue) {
      if (newValue != oldValue) {
        this.initAutoplay()
      }
    }
  },
  data() {
    return {
      hasPrev: false,
      hasNext: false,
      active: 0,
      pages: null,
      inView: null
    }
  },
  computed: {
    itemsPerView() {
      return this.$screen.match(this.slidesPerView)
    },
    trackActiveItem() {
      return this.itemsPerView == 1 ||
        this.containScroll == 'keepSnaps' ||
        this.loop == true
    },
    total() {
      return this.items.length
    }
  },
  methods: {
    create(el) {
      this.carousel = createCarousel(this, el)
      this.$emit('create', this)

      this.carousel.on('init', this.onInit)
      this.carousel.on('reInit', this.onReInit)
      this.carousel.on('select', this.onSelect)
    },
    update(event) {
      this.hasPrev = this.call('canScrollPrev')
      this.hasNext = this.call('canScrollNext')
      this.active  = this.call('selectedScrollSnap')
      this.pages   = this.call('scrollSnapList')
      this.inView  = this.call('slidesInView', true)

      this.$emit(hyphenate(event || 'update'), this)
    },
    call(name, ...args) {
      const method = this.carousel && this.carousel[name]

      if (method) {
        return method.call(null, ...args)
      } else {
        console.warn(`Embla carousel method "${method}" does not exist!`)
      }
    },
    initAutoplay() {
      this.destroyAutoplay()

      if (this.carousel) {
        this.player = autoplay(this.carousel, this.autoplayInterval)
        this.startAutoplay()
      }
    },
    stopAutoplay() {
      if (this.player) {
        this.player.stop()
        this.carousel.off('pointerDown', this.player.stop)
      }
    },
    startAutoplay() {
      if (this.player && this.autoplay) {
        this.player.play()
        this.carousel.on('pointerDown', this.player.stop)
      }
    },
    destroyAutoplay() {
      this.stopAutoplay()
      this.player = null
    },
    onInit() {
      this.update('init')
      this.initAutoplay()
    },
    onReInit() {
      this.update('reInit')
      this.initAutoplay()
    },
    onSelect() {
      this.update('select')
    },
    scrollPrev() {
      this.stopAutoplay()
      this.call('scrollPrev')
    },
    scrollNext() {
      this.stopAutoplay()
      this.call('scrollNext')
    },
    scrollTo(index) {
      this.stopAutoplay()
      this.call('scrollTo', index)
    },
    isPageActive(index) {
      return this.active == index
    },
    isItemActive(index) {
      return this.trackActive &&
        this.trackActiveItem &&
        this.isPageActive(index)
    },
    itemInView(index) {
      return this.trackInView &&
        this.inView &&
        this.inView.includes(index)
    }
  },
  beforeDestroy() {
    this.destroyAutoplay()

    if (this.carousel) {
      this.carousel.destroy()
    }
  }
}
